"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/table/style/css");

var _table = _interopRequireDefault(require("antd/es/table"));

var _lodash = require("lodash");

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reselect = require("reselect");

var _Util = require("../util/Util");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const columns = [{
  title: 'ID',
  dataIndex: 'id',
  key: 'id',
  sorter: (a, b) => a.id - b.id
}, {
  title: 'Type',
  dataIndex: 'type',
  key: 'type',
  sorter: (a, b) => `${a.type}`.localeCompare(b.type)
}, {
  title: 'Request Date',
  dataIndex: 'requestDate',
  key: 'requestDate',
  render: _Util.renderPopoverDate,
  sorter: (a, b) => (0, _moment.default)(a.requestDate).unix() - (0, _moment.default)(b.requestDate).unix(),
  defaultSortOrder: 'descend'
}, {
  title: 'Address',
  dataIndex: 'firstName',
  key: 'firstName',
  render: (value, row) => {
    const {
      firstName,
      lastName,
      address1,
      address2,
      city,
      state,
      postalCode
    } = row;
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        lineHeight: '12px'
      }
    }, /*#__PURE__*/_react.default.createElement("p", null, firstName, ' ', lastName), /*#__PURE__*/_react.default.createElement("p", null, address1), !_lodash._.isEmpty(address2) ? /*#__PURE__*/_react.default.createElement("p", null, address2) : undefined, /*#__PURE__*/_react.default.createElement("p", null, city, ",", ' ', state, ' ', postalCode));
  }
}, {
  title: 'Sent Date',
  dataIndex: 'sentDate',
  key: 'sentDate',
  render: _Util.renderPopoverDate,
  sorter: (a, b) => (0, _moment.default)(a.sentDate).unix() - (0, _moment.default)(b.sentDate).unix()
}, {
  title: 'Estimated Delivered Date',
  dataIndex: 'estimatedDeliveryDate',
  key: 'estimatedDeliveryDate',
  render: _Util.renderPopoverDate,
  sorter: (a, b) => (0, _moment.default)(a.estimatedDeliveryDate).unix() - (0, _moment.default)(b.estimatedDeliveryDate).unix()
}, {
  title: 'Tracking Number',
  dataIndex: 'trackingNumber',
  key: 'trackingNumber',
  sorter: (a, b) => `${a.trackingNumber}`.localeCompare(b.trackingNumber)
}, {
  title: 'Delivered Date',
  dataIndex: 'deliveredDate',
  key: 'deliveredDate',
  render: _Util.renderPopoverDate,
  sorter: (a, b) => (0, _moment.default)(a.deliveredDate).unix() - (0, _moment.default)(b.deliveredDate).unix()
}, {
  title: 'Received Date',
  dataIndex: 'receivedDate',
  key: 'receivedDate',
  render: _Util.renderPopoverDate,
  sorter: (a, b) => (0, _moment.default)(a.receivedDate).unix() - (0, _moment.default)(b.receivedDate).unix()
}, {
  title: 'Report Date',
  dataIndex: 'reportDate',
  key: 'reportDate',
  render: _Util.renderPopoverDate,
  sorter: (a, b) => (0, _moment.default)(a.reportDate).unix() - (0, _moment.default)(b.reportDate).unix()
}, {
  title: 'Completed Date',
  dataIndex: 'completedDate',
  key: 'completedDate',
  render: _Util.renderPopoverDate,
  sorter: (a, b) => (0, _moment.default)(a.completedDate).unix() - (0, _moment.default)(b.completedDate).unix()
}];

const rowClassName = (record, index) => {
  return index % 2 === 0 ? 'tr-even-color' : 'tr-odd-color';
};

class TestkitTable extends _react.PureComponent {
  render() {
    const {
      participantTestkits
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_table.default, {
      columns: columns,
      dataSource: participantTestkits,
      pagination: {
        pageSize: 20
      },
      rowClassName: rowClassName,
      rowKey: "id"
    }));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({});

const mapDispatchToProps = dispatch => {
  return {};
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TestkitTable);

exports.default = _default;